module.exports = __webpack_public_path__ + "static/sheep4-56ddc6fe129a1b276a90ab3b51a5661a.jpeg";